import { useState, useEffect } from 'react';
import { adminGet } from '../lib/api';

interface Prompt { id: string; name: string; description: string; version: string; category: string; enabled: boolean; sourceOfTruth: string; updatedAt: string | null; }

export function PromptLibrary() {
  const [prompts, setPrompts] = useState<Prompt[]>([]);

  useEffect(() => {
    (async () => {
      const resp = await adminGet('/api/admin/rights-prompts');
      if (resp.ok && resp.data) setPrompts((resp.data as { prompts: Prompt[] }).prompts || []);
    })();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-display font-bold text-white mb-6">Prompt Library (Rights)</h1>
      <div className="bg-dark-700 rounded-2xl border border-dark-650/50 overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-dark-650/50">
              <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Prompt</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Version</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Source</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-dark-650/30">
            {prompts.map(p => (
              <tr key={p.id} className="hover:bg-dark-750/50 transition-colors">
                <td className="px-4 py-3">
                  <div className="text-sm text-white font-medium">{p.name}</div>
                  <div className="text-xs text-dark-500 font-mono mt-0.5">{p.id}</div>
                </td>
                <td className="px-4 py-3 text-sm font-mono text-dark-400">{p.version}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 text-xs rounded ${p.sourceOfTruth === 'd1' ? 'bg-rights-500/10 text-rights-500' : 'bg-dark-600 text-dark-400'}`}>
                    {p.sourceOfTruth || 'file'}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 text-xs rounded ${p.enabled ? 'bg-severity-low/10 text-severity-low' : 'bg-dark-600 text-dark-400'}`}>
                    {p.enabled ? 'Enabled' : 'Disabled'}
                  </span>
                </td>
              </tr>
            ))}
            {prompts.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-dark-500">No Rights prompts found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
